import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogPassportComponent } from '@shared/components/passport/catalog-passport.component';
import { HistoryVersionListComponent } from '@shared/components/passport/history-version-list-modal/history-version-list-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SvgModule } from '@shared/components/svg/svg.module';
import { RouterModule } from '@angular/router';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';

@NgModule({
  declarations: [CatalogPassportComponent, HistoryVersionListComponent],
  imports: [CommonModule, TranslateModule, MatTooltipModule, SvgModule, RouterModule, NgLetModule],
  exports: [CatalogPassportComponent]
})
export class PassportModule {}
